import { useNavigate } from "react-router";
import { Box, Stack } from "@mui/material";
import i18n from "i18n";
import React from "react";
import { StyledButton } from "customStyled";

const FormFooter = ({
  path,
  skip,
  pathColor = "primary",
  back,
  backClick,
  pathText = i18n.t("common:continue"),
  backText = i18n.t("common:goBack"),
  skipText = i18n.t("common:skipForNow"),
  handleSubmit = null,
  skipSubmit = null,
  pathDisabled = false,
  isSpaceBetween = false,
  fullsize = false,
  deleteUI = null,
}) => {
  const navigate = useNavigate();
  const backUI =
    back || backClick ? (
      <StyledButton
        variant="outlined"
        size="large"
        fullWidth={fullsize}
        onClick={(e) => {
          if (backClick) {
            backClick(e);
          } else {
            navigate(back);
          }
        }}
      >
        {backText}
      </StyledButton>
    ) : null;
  return (
    <React.Fragment>
      <Stack
        spacing={2}
        direction="row"
        sx={{
          gap: 1.5,
          justifyContent: "flex-end",
          alignItems: "center",
          flexGrow: fullsize ? 1 : 0,
          padding: "10px 24px",
        }}
      >
        {deleteUI}
        {isSpaceBetween ? backUI : null}
        {fullsize ? null : <Box sx={{ flexGrow: 1 }}></Box>}
        {!isSpaceBetween ? backUI : null}
        {skip || skipSubmit ? (
          <StyledButton
            variant="text"
            size="large"
            onClick={() => (skipSubmit ? skipSubmit() : navigate(skip))}
          >
            {skipText}
          </StyledButton>
        ) : null}
        {path || handleSubmit ? (
          <StyledButton
            variant="contained"
            size="large"
            fullWidth={fullsize}
            color={pathColor}
            disabled={pathDisabled}
            onClick={(event) =>
              handleSubmit ? handleSubmit(event) : navigate(path)
            }
          >
            {pathText}
          </StyledButton>
        ) : null}
      </Stack>
    </React.Fragment>
  );
};

export default FormFooter;
